import { AfterViewInit, ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms';
import { Currencies } from '../../../../../core/constants/currency';
import { Permissions } from '../../../../../core/constants/permissions';
import { enumToText } from '../../../../../core/helpers/enum-to-text.function';
import { BankCoverFee, PaymentMethod, BankTransferMethod } from '../../../../../core/models/patient.model';
import { SelectOption } from '../../../../../core/models/select-option.model';
import { AuthService } from '../../../../../core/services/auth.service';
import { DropdownInputComponent } from '../../../../../shared/dropdown-input/dropdown-input.component';
import { v4 as uuidv4 } from "uuid";

@Component({
  selector: 'app-payment-info-general-settings',
  templateUrl: './payment-info-general-settings.component.html',
  styleUrls: ['./payment-info-general-settings.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PaymentInfoGeneralSettingsComponent implements AfterViewInit {
  @ViewChild("bankCoverFeeCurrencySelect") bankCoverFeeCurrencySelect: DropdownInputComponent;
  @ViewChild("defaultPaymentMethodSelect") defaultPaymentMethodSelect: DropdownInputComponent;
  @ViewChild("bankTransferMethodSelect") bankTransferMethodSelect: DropdownInputComponent;

  @Input() trialCaxtonEnabled: boolean;
  @Input() paymentInfoForm: FormGroup;

  bankTransferMethods: SelectOption[] = [
    {
      value: BankTransferMethod.Manual.toString(),
      text: enumToText(BankTransferMethod, BankTransferMethod.Manual)
    },
    {
      value: BankTransferMethod.Automated.toString(),
      text: enumToText(BankTransferMethod, BankTransferMethod.Automated)
    }];

  defaultPaymentMethods: SelectOption[] = [
    {
      value: PaymentMethod.BankTransfer.toString(),
      text: enumToText(PaymentMethod, PaymentMethod.BankTransfer),
    },
    {
      value: PaymentMethod.CaxtonCard.toString(),
      text: enumToText(PaymentMethod, PaymentMethod.CaxtonCard),
    }
  ];

  currencies: SelectOption[] = Currencies.all().map((x) => ({ value: x.cc, text: `${x.name} (${x.cc})` }));
  bankFeeCoverData: BankCoverFee[] = [];

  PaymentMethod = PaymentMethod;
  BankTransferMethod = BankTransferMethod;
  Permissions = Permissions;

  constructor(public authService: AuthService, private cd: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.bankTransferMethodSelect.setValue(this.paymentInfoForm.get('bankTransferMethod').value);
    this.defaultPaymentMethodSelect.setValue(this.paymentInfoForm.get('defaultPaymentMethod').value);
    this.bankCoverFeeCurrencySelect.setValue(this.paymentInfoForm.get('bankCoverFeeCurrency').value);

    this.cd.detectChanges();
  }

  addNmibleCardOption(): void {
    this.defaultPaymentMethods.push({
      value: PaymentMethod.NmibleCard.toString(),
      text: enumToText(PaymentMethod, PaymentMethod.NmibleCard),
    });
  }

  setNmibleCardDisplayOnly(): void {
    this.defaultPaymentMethodSelect.selectedValueText = enumToText(PaymentMethod, PaymentMethod.NmibleCard);
    this.defaultPaymentMethodSelect.hasPlaceholder = false;
  }

  addNmibleBankOption(): void {
    this.defaultPaymentMethods.push({
      value: PaymentMethod.NmibleBank.toString(),
      text: enumToText(PaymentMethod, PaymentMethod.NmibleBank),
    });
  }

  setNmibleBankDisplayOnly(): void {
    this.defaultPaymentMethodSelect.selectedValueText = enumToText(PaymentMethod, PaymentMethod.NmibleBank);
    this.defaultPaymentMethodSelect.hasPlaceholder = false;
  }

  loadBankCoverFeeComponent() {
    let fee = {
      id: uuidv4().toString().replace("-", ""),
      thresholdValue: 0,
      feeValue: 0,
    };

    this.bankFeeCoverData.push(fee);
    this.paymentInfoForm.markAsDirty();
  }

  removeBankFeeCoverComponent(index: string) {
    this.bankFeeCoverData = this.bankFeeCoverData.filter((e) => e.id !== index);
    this.paymentInfoForm.markAsDirty();
  }

  populateBankCoverFeeData(data: BankCoverFee) {
    let componentData = this.bankFeeCoverData.find((d) => d.id === data.id);
    componentData.thresholdValue = data.thresholdValue;
    componentData.feeValue = data.feeValue;
    this.paymentInfoForm.markAsDirty();
  }
}
